
import React, {Component} from "react";
import {HashRouter, Route, Routes } from "react-router-dom";
import DefaultDashboardPage from "./Pages/Dashboards/Default.js";
import AdjustWorkTimesPage from './Pages/AdjustWorkTimesPage.js';
import ToursOfferedPage from './Pages/ToursOfferedPage.js';
import DayTypesPage from './Pages/DayTypesPage.js';
import DayTypeCalendarView from './Components/DayType/DayTypeCalendarView.js';
import DayTypeRequestsView from './Components/DayType/DayTypeRequestsView.js';
import SchedulesPage from './Pages/SchedulesPage.js';
import AboutPage from './Pages/AboutPage.js';
import PostedSchedulesPage from './Components/Schedule/PostedSchedulesPage.js';
import ShortPostedScheduleView from './Components/Schedule/OneTwoDay/PostedScheduleView.js';
import LongPostedScheduleView from './Components/Schedule/SevenNineDay/PostedScheduleView.js';
import ShortLiveScheduleView from './Components/Schedule/OneTwoDay/LiveScheduleView.js';
import LongLiveScheduleView from './Components/Schedule/SevenNineDay/LiveScheduleView.js';
import DetailedScheduleView from './Components/Schedule/DetailedSchedule/DetailedScheduleView.js';
import MyQuickScheduleView from './Components/Schedule/MyQuickSchdeuleView.js';
import ApprovalView from './Components/Approval/ApprovalView.js';

import PageNotFound from './Pages/Theme/Error.js';
import BlankPage from "./Pages/Theme/Page.js";

const ServiceNow = ()=> {window.location.href ='https://nbcu.service-now.com/nbcusp?id=sc_cat_item&sys_id=a8108f526f922500e904f00dba3ee458&sysparm_appID=7039838'; return null;};

export default class AppRouter extends Component {
    
    render() {
        return (
            <HashRouter>
                <div>
                <Routes>
                    <Route exact path="/" Component={DefaultDashboardPage}/>

                    {/* Schedule Domain */}
                    <Route exact path="/my-quick-schedule" Component={MyQuickScheduleView}/>
                    <Route exact path="/schedules" Component={SchedulesPage}/>
                    <Route exact path="/posted-schedules" Component={PostedSchedulesPage}/>
                    <Route exact path="/posted-schedule-view-short" Component={ShortPostedScheduleView}/>
                    <Route exact path="/posted-schedule-view-long" Component={LongPostedScheduleView} />
                    <Route exact path="/live-schedule-view-short" Component={ShortLiveScheduleView}/>
                    <Route exact path="/live-schedule-view-long" Component={LongLiveScheduleView}/>
                    <Route exact path="/detailed-schedule-view" Component={DetailedScheduleView}/>

                    {/* Adjust-Work-Times Domain */}
                    <Route exact path="/adjust-work-times" Component={AdjustWorkTimesPage}/>

                    {/* Tours-Offered Domain */}
                    <Route exact path="/tours-offered" Component={ToursOfferedPage}/>

                    {/* Day-Type Domain */}
                    <Route exact path="/day-types" Component={DayTypesPage}/>
                    <Route exact path="/day-types-requests-view" Component={DayTypeRequestsView}/>
                    <Route exact path="/day-types-calendar-view" Component={DayTypeCalendarView}/>
                    <Route exact path='/service-now' Component={ServiceNow}/>

                    {/* Approvals Domain */}
                    <Route exact path="/approvals" Component={ApprovalView}/>

                    {/* About */}
                    <Route exact path="/about" Component={AboutPage}/>

                    <Route exact path="/page" Component={BlankPage}/>
                    <Route Component={PageNotFound}/>
                </Routes>

                </div>
            </HashRouter>
        )
    }
}


